import { Button } from "@deere/fuel-react";
import RefreshIcon from "@mui/icons-material/Refresh";

import ButtonComponent from "../../components/buttonComponent";
import Locations from "../left-filter/location";

const OrderManagementHeader = ({ getTableData }) => {
  const handleClick = () => {
    getTableData();
  };
  return (
    <div>
      <div className="flex flex-nowrap space-x-2 w-full pl-2 mr-0 justify-between">
        <div class="w-full pt-2">
          <Locations />
        </div>

        <div className="w-full pt-2">
          <b className="text-xs">Order Management</b>
        </div>
        <ButtonComponent
          tooltip={"Refresh Data"}
          handleFunction={handleClick}
          variant={null}
        >
          <RefreshIcon style={{ fontSize: "20px" }} />
        </ButtonComponent>
      </div>
    </div>
  );
};

export default OrderManagementHeader;
